module.exports = __webpack_public_path__ + "static/icon_number02-ebbc40e42db000af97ead1ea7d05179b.png";